import React from 'react';

import PropTypes from 'prop-types';
import SanitizedHTML from 'react-sanitized-html';

import { SlideDownContent } from 'cstar-react-primitives';

import { useFormatMessage } from '../../../intl/intlHooks';
import { personalizationFormMessages } from './giftCardMessages';

export const GiftCardDetails = ({ description, redemptionText, termsAndConditions, className }) => {
    const formatMessage = useFormatMessage();
    const descriptionProps = {
        label: formatMessage(personalizationFormMessages.slideDownDescriptionLabel),
        bottomBorder: true,
        startOpen: true,
        render: () => <SanitizedHTML html={description} />
    };

    const termsAndConditionsProps = {
        label: formatMessage(personalizationFormMessages.slideDownTermsAndConditionsLabel),
        bottomBorder: true,
        topBorder: false,
        render: () => <SanitizedHTML html={termsAndConditions} />
    };

    const redemptionTextProps = {
        label: formatMessage(personalizationFormMessages.slideDownRedemptionDetailsLabel),
        bottomBorder: true,
        topBorder: false,
        render: () => <SanitizedHTML html={redemptionText} />
    };

    return (
        <div className={`gift-card-details ${className}`}>
            {description && <SlideDownContent {...descriptionProps} />}
            {termsAndConditions && <SlideDownContent {...termsAndConditionsProps} />}
            {redemptionText && <SlideDownContent {...redemptionTextProps} />}
        </div>
    );
};

GiftCardDetails.propTypes = {
    description: PropTypes.string,
    termsAndConditions: PropTypes.string,
    redemptionText: PropTypes.string,
    className: PropTypes.string,
};

GiftCardDetails.defaultProps = {
    description: '',
    termsAndConditions: '',
    redemptionText: '',
    className: '',
};

export default GiftCardDetails;
